const COLORS = [
  'bg-indigo-500/20 text-indigo-700 dark:text-indigo-300',
  'bg-emerald-500/20 text-emerald-700 dark:text-emerald-300',
  'bg-amber-500/20 text-amber-700 dark:text-amber-300',
  'bg-rose-500/20 text-rose-700 dark:text-rose-300',
  'bg-sky-500/20 text-sky-700 dark:text-sky-300',
  'bg-violet-500/20 text-violet-700 dark:text-violet-300',
]

function hashString(value: string): number {
  let hash = 0
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export function avatarColorClass(seed: string): string {
  return COLORS[hashString(seed) % COLORS.length]
}
